enum KnowledgeBaseDisplayContentType {
  IMAGE = 'IMAGE',
  VIDEO = 'VIDEO',
  AUDIO = 'AUDIO',
  PDF = 'PDF',
  UNSUPPORTED = 'UNSUPPORTED',
}

export { KnowledgeBaseDisplayContentType }
